import api from './api';

const adminDepartmentsService = {
  // Get all departments with pagination and filtering
  async getDepartments(params = {}) {
    try {
      const response = await api.get('/admin/departments', { params });
      return response.data;
    } catch (error) {
      console.error('Failed to get departments:', error);
      throw error;
    }
  },

  // Get department by ID
  async getDepartment(id) {
    try {
      const response = await api.get(`/admin/departments/${id}`);
      return response.data;
    } catch (error) {
      console.error('Failed to get department:', error);
      throw error;
    }
  },

  // Create new department
  async createDepartment(departmentData) {
    try {
      const response = await api.post('/admin/departments', departmentData);
      return response.data;
    } catch (error) {
      console.error('Failed to create department:', error);
      throw error;
    }
  },

  // Update department
  async updateDepartment(id, departmentData) {
    try {
      const response = await api.put(`/admin/departments/${id}`, departmentData);
      return response.data;
    } catch (error) {
      console.error('Failed to update department:', error);
      throw error;
    }
  },

  // Delete department (soft delete)
  async deleteDepartment(id) {
    try {
      const response = await api.delete(`/admin/departments/${id}`);
      return response.data;
    } catch (error) {
      console.error('Failed to delete department:', error);
      throw error;
    }
  }
};

export default adminDepartmentsService;